
import { darkTheme,  sitesData } from '../allimports.js'
import * as React from 'react';

import 'react-tiff/dist/index.css'
import { Map, MapContainer, useMap, GeoJSON, useMapEvents, Marker, Popup, TileLayer, MinimapControl } from 'react-leaflet'

import "leaflet/dist/leaflet.css";
import L from "leaflet";

import { RichTreeView } from '@mui/x-tree-view/RichTreeView';

import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';

import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';

import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';

import InfoIcon from '@mui/icons-material/Info';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import HeaderToolbar from './header.js';
import Footer from './footer.js';
import { AircraftQC } from './AircraftQC/AircraftQC.js';
//import { AircraftPlot } from './AircraftPlot.js';
//import { AircraftSceneSummary } from './AircraftQC/AircraftSceneSummary.js';
//import { QCImageAircraft } from './AircraftQC/QCImageAircraft.js';
//import { QCingFormAircraft } from './AircraftQC/QCingFormAircraft.js';
import './EIAM.css';
//import TiffViewer from './components/TiffViewer.js';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {mockSites,mockOutcome,mockAircrafts,mockHistory,mockImages,mockImagesTree,mockMaster} from '../mocks.js'
const restserver = "http://localhost:5000/";

var folders = require('../images.json');

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}`,
    srcSet: `${image}`,
  };
}

export default function EIAM() {
  const [siteImages, setSiteImages] = React.useState(folders[0].children);
  const [testResp, setTestResp] = React.useState('');
  const [appStep, setStep] = React.useState(0);
  const [selectedSite, setSite] = React.useState('');
  const [selectedAlgo, setAlgo] = React.useState('');
  // const [folders,setfolders] = React.useState('[]')

  const selectSite = (newVal) => () => {
    if (newVal == undefined) {
      setStep(appStep + 1); return;
    }
    var newnode = searchNode(folders, newVal);
    console.log('siteSelect', newVal);
    if (newnode && newnode.children && newnode.label != selectedSite) {
      setSelectedRefItems('');
      setSelectedTrgItems('');
      setSiteImages(newnode.children)
      setSite(newnode.label);

      fetch('/app/' + newnode.site + '.geojson') // Replace with your URL
        .then(response => response.json())
        .then(data => setGeoJsonData(data))
        .catch(error => console.error('Error fetching data:', error));

    }
    console.log('siteSelect', newVal);
   // setStep(appStep + 1);

  };
  const selectAlgo = (newVal) => () => {
    setAlgo(newVal);
    console.log('siteSelect', newVal);
    setStep(appStep + 1);
  };

  const handleRefSelectedItemsChange = (event, ids) => {
    console.log('event', event, 'ids', ids);
    const node = searchNode(folders, ids);
    if (node && node.label && (!node.children || node.children.length == 0)) {
      setSelectedRefItems(node.label);
      setSelectedRefID(ids);
    }
  };
  const handleTrgSelectedItemsChange = (event, ids) => {
    console.log('event', event, 'ids', ids);
    const node = searchNode(folders, ids);
    if (node && node.label && (!node.children || node.children.length == 0)) {
      setSelectedTrgItems(node.label);
      setSelectedTrgID(ids);
    }
  };

  function searchNode(nodes, key) {
    //   console.log("SearchNode:",nodes,key);
    for (const node of nodes) {
      //  console.log("Looking :", node.id);
      // Check if the current node's id matches the key
      if (node.id === key) {
        //   console.log("Found:", node);
        return node;
      }

      // If there are children, perform a recursive search
      if (node.children && node.children.length > 0) {
        //   console.log("Looking Child:", node.id);
        const foundNode = searchNode(node.children, key);

        if (foundNode) {
          //     console.log("Child Found:", foundNode);
          return foundNode; // Return the found node
        }
      }
    }

    // Return null if the node was not found
    return null;
  }
  const [geoJsonData, setGeoJsonData] = React.useState(null);
  const [selectedRefItems, setSelectedRefItems] = React.useState([]);
  const [selectedTrgItems, setSelectedTrgItems] = React.useState([]);
  const [selectedRefID, setSelectedRefID] = React.useState('');
  const [selectedTrgID, setSelectedTrgID] = React.useState('');

  const GeoJSONOverlay = ({ data }) => {
    const map = useMap();
    React.useEffect(() => {
      if (data) {
        const geoJsonLayer = new L.GeoJSON(data);
        const bounds = geoJsonLayer.getBounds();
        map.fitBounds(bounds); // Center and zoom to GeoJSON bounds
      }
    }, [data, map]);
    return data ? <GeoJSON data={data} /> : null;
  };

  const handleStep = (panel) => (event, isExpanded) => {
    console.log('panel', panel, event, isExpanded);
    setStep(isExpanded ? panel : (appStep + 1));
  };

  const handleNRMSE = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  const handleSites= () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  const handleImages= () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  const handleAircrafts = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };

  const handlegeoJson = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  const handleHistory = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  const handleOutcome = () => (event) => {
    console.log('Button Clicked', event);
    var url = restserver + 'test/nrmse/' + selectedRefID + '/' + selectedTrgID
    //var url='/test/nrmse/'+selectedRefID + '/' + selectedTrgID 
    console.log('url', url);
    fetch(url)
      .then(response => response.json())
      .then(data => setTestResp(data));
  };
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <HeaderToolbar />
      <div className="App">

        {/* Sites Panel */}
        <Accordion expanded={appStep == 0} onChange={handleStep(0)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header"  >
           Site Selection:  <span className='headingCaps'>{selectedSite}</span>
          </AccordionSummary>
          <AccordionDetails>
          <div id="images">
      
          <ImageList variant="quilted" sx={{width: '50%', height: 450 }} cols={2} rowHeight={220}>
              {sitesData.map((item) => (
                <ImageListItem sx={{ border: 2, cursor: 'pointer' }} key={item.img} cols={item.cols || 1} rows={item.rows || 1} onClick={selectSite(item.id)}>
                  <img
                    {...srcset(item.img, 225, item.rows, item.cols)}
                    alt={item.title}
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.title}
                    subtitle={item.location}
                    actionIcon={
                      <IconButton
                        sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                        aria-label={`info about ${item.title}`}
                        onClick={selectSite(item.title)}
                      >
                        <InfoIcon />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>

      
          <Card sx={{ left: 50, minWidth: 275, maxWidth: '50%', height:450, background: "#eee" }}>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Site Images
                  </Typography>
                  <RichTreeView id="tree" items={mockImagesTree} onSelectedItemsChange={handleRefSelectedItemsChange} />
                </CardContent>
                <CardActions>  
                  {/*
                  <Alert severity="success">  {testResp.message}   </Alert>
                
                  <Button color="warning" variant="contained" onClick={handleNRMSE()}>Upload new images</Button>
                */}
                  <Button variant="contained" onClick={selectSite()}>Select images</Button>
                </CardActions>
              </Card>
           
          </div>
         
          </AccordionDetails>
        </Accordion>

        {/* Algorithm Panel */}
        <Accordion expanded={appStep == 1} onChange={handleStep(1)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
            Aircraft Detecton Results: <span className='headingCaps'>{selectedRefItems}</span>
          </AccordionSummary>
          <AccordionDetails>
          <AircraftQC />

          </AccordionDetails>
        </Accordion>
        <Accordion expanded={appStep == 2} onChange={handleStep(2)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
            Alerts Management
          </AccordionSummary>
          <AccordionDetails>
          <div>
          <FormGroup>
      <FormControlLabel control={<Switch defaultChecked  color="secondary"/>} label="20% More than rolling average of 7 " />
      <FormControlLabel  control={<Switch defaultChecked />} label="50% Less than rolling average of 7 " />
      <FormControlLabel  control={<Switch defaultChecked  />} label="50% Less than rolling average of 7" />
      <FormControlLabel  control={<Switch defaultChecked color="warning" />} label="New Type of Aircraft detected on Site with >90% confidence" />
   
    </FormGroup>
    </div>
                  {/* 
          <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={true}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              />

              <GeoJSONOverlay data={geoJsonData} />
            </MapContainer>
            */}
          </AccordionDetails>
        </Accordion>
        {/* Images Panel */}

      </div>
      <Footer />
    </ThemeProvider>
  );
}

